import App from "../../services/App/App.js";
import Catalog from "./DbpyCatalog.js";

export default {
  setDetailsByEditData(userData, debtPayData, statusEnum) {
    userData.ID = debtPayData.ID;

    if (debtPayData.StatusID === statusEnum.Active.ID) {
      userData.StatusID = statusEnum.Void.ID;
    }
  },

  getDebtPaySectionHelp(debtPayData) {
    return Catalog.PayNumber.Label + ": " +
      App.Value.getValue("PayNumber", debtPayData, Catalog) + ", " +
      Catalog.Date.Label + ": " +
      App.Value.getValue("Date", debtPayData, Catalog);
  },

  populateData(userData) {
    // target StatusID: Void
    return {
      ID: userData.ID,
      StatusID: userData.StatusID,
      VoidComment: App.Out.getString(userData.VoidComment)
    };
  }
}